module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-7-b9cad8a80468ea8c1bdee52607b7a25e.jpg";